'use client'

import { lazy, Suspense, useSyncExternalStore } from 'react'

// Hydration-gated lazy import instead of next/dynamic ssr:false: identical
// behavior (server renders nothing, the client loads the banner chunk after
// hydration) without the client-rendering bailout that blocks prerendering.
const ImpersonationBanner = lazy(() =>
  import('./impersonation-banner').then((m) => ({
    default: m.ImpersonationBanner,
  }))
)

const subscribeToHydration = () => () => undefined
const getClientHydrationSnapshot = (): boolean => true
const getServerHydrationSnapshot = (): boolean => false

export function ImpersonationBannerClient() {
  const hydrated = useSyncExternalStore(
    subscribeToHydration,
    getClientHydrationSnapshot,
    getServerHydrationSnapshot
  )
  if (!hydrated) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <ImpersonationBanner />
    </Suspense>
  )
}
